<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>订单预警</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box" v-if=searchIsShow>
				<el-select v-model="query.orderType" placeholder="请选择订单类型" @change="queryOrderTypeChange">
					<el-option key="0" label="采购" value="0"></el-option>
					<el-option key="1" label="销售" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.orderCompanyId" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in queryCompanysKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="orderNo" label="订单编号" width="130"></el-table-column>
				<el-table-column prop="orderType" label="订单类型" :formatter="orderTypeFormat" width="80"></el-table-column>
				<el-table-column prop="orderCompanyName" label="公司名称" width="250"></el-table-column>
				<el-table-column prop="status" label="状态" width="100" :formatter="statusFormat">
					<template slot-scope="scope">{{statusFormat(scope.row, null, scope.row.status)}}</template>
				</el-table-column>
				<el-table-column prop="createTime" label="预警时间" width="160"></el-table-column>
				<el-table-column prop="warningInfo" label="预警信息"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-show"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >解除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加预警记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="订单类型" prop="orderType">
					<el-select v-model="form.orderType" placeholder="请选择订单类型" @change="formOrderTypeChange">
						<el-option key="0" label="采购" value="0"></el-option>
						<el-option key="1" label="销售" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="公司" prop="orderCompanyId">
					<el-select v-model="form.orderCompanyId" placeholder="请选择公司" filterable @change="orderCompanyChange">
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in formCompanysKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="预警订单" prop="orderCompanyId">
					<el-select v-model="form.orderId" placeholder="请选择订单" filterable>
						<el-option key="" label="请选择订单" value=""></el-option>
						<el-option v-for="item in ordersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="预警信息" prop="warningInfo">
					<el-input type=textarea :rows=3 v-model="form.warningInfo"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="订单信息" :visible.sync="showVisible" width="75%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="3" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							供货公司
						</template>
						{{show.orderCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							经办人
						</template>
						{{show.operator}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							电话
						</template>
						{{show.tel}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单时间
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							合同编号
						</template>
						{{show.contractNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单数量
						</template>
						{{show.total}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单金额
						</template>
						￥{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单状态
						</template>
						{{statusFormat(show, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							支付方式
						</template>
						<el-tag :type= "(show.payReceipt > '' || show.balancePayment > 0)?'success':((show.payType===2 && new Date(show.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, show.payType)}}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.payType===2 && !show.payReceipt">
						<template slot="label">
							支付日期
						</template>
						{{show.payTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if = "show.balancePayment>0">
						<template slot="label">
							余额支付
						</template>
						￥{{show.balancePayment}}
					</el-descriptions-item>
					<el-descriptions-item  v-if = "show.payReceipt">
						<template slot="label">
							现金支付
						</template>
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in show.payReceipt.split(',')" :key="index">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								></el-image>
							</div>
						</el-tooltip>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							冲账确认
						</template>
						{{show.payConfirmId > 0?show.payConfirmName:"待确认"}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.payConfirmId > 0 && show.status<6">
						<template slot="label">
							冲账时间
						</template>
						{{show.payConfirmTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.payConfirmId > 0 && show.status<6">
						<template slot="label">
							冲账说明
						</template>
						{{show.payConfirmRemark}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							到货状态
						</template>
						{{arrivalStatusFormat(show, null, show.arrivalStatus)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							是否开票
						</template>
						{{show.invoiceStatus?'已开票':'未开票'}} 
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							票据编号
						</template>
						{{show.invoiceNo}} 
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px;">
					<el-col :span="24">
						<el-table
							:data="orderShowDetails"
							border
							class="table"
							header-cell-class-name="table-header"
							:cell-style="{padding:1+'px'}"
							stripe
						>
							<el-table-column prop="id" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index + 1}}
								</template>
							</el-table-column>
							<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
							<el-table-column prop="productName" label="型号" width="150"></el-table-column>
							<el-table-column prop="num" label="数量" width="60"></el-table-column>
							<el-table-column prop="unit" label="单位" width="50" :formatter="unitFormat"></el-table-column>
							<el-table-column prop="price" label="单价" width="70"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
							<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
							<el-table-column prop="remark" label="备注"></el-table-column>
							<el-table-column prop="arrivalStatus" label="到货状态" width="80">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":arrivalStatusFormat(scope.row, null, scope.row.arrivalStatus)}}</template>
							</el-table-column>
							<el-table-column prop="arrivalTime" label="到货时间" width="155">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.arrivalTime}}</template>
							</el-table-column>
							<el-table-column prop="stockId" label="库存编号" width="80">
							<template slot-scope="scope">{{scope.row.productName==="运费"||scope.row.productName==="维修费"?"--":scope.row.stockId}}</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchOrderWarningData, saveOrderWarning, deleteOrderWarning, getOrder, getChannelKV, getAllCustomerKV, fetchReconciliationOrders } from '../../../api/index';
export default {
    name: 'order-warning',
    data() {		
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
                orderType: [{ required: true, message: '请选择订单类型', trigger: 'blur' }],
				orderCompanyId: [{ required: true, message: '请选择公司', trigger: 'blur' }],
				orderId: [{ required: true, message: '请选择订单', trigger: 'blur' }],
				warningInfo: [{ required: true, message: '预警信息不能为空', trigger: 'blur' }]
            },
			show:{},
			orderShowDetails:[],
			showVisible:false,
			queryCompanysKV:[],
			orderType:0,
			formCompanysKV:[],
			ordersKV:[],
			deleteIsShow:false,
			addIsShow:false,
			searchIsShow:false,
			unitCode:1012,
			unitKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("order-warning");
		if (this.$route.orderType != undefined) {
			this.query.orderType = this.$route.orderType;
		}
		if (this.$route.orderCompanyId != undefined) {
			this.query.orderCompanyId = this.$route.orderCompanyId;
		}
        this.getData();
    },
    methods: {
		//获取产品信息
		getUnits() {
			getEnumValueKV(this.unitCode).then(res => {
				if (res.code == 0) {
					this.unitKV = res.data;
				} else {
					this.$message.error(`获取单位信息失败！` + res.message);
				}
			})
		},
		//单位格式化
		unitFormat(row, column, cellValue){
			let index = this.unitKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.unitKV[index].value;
		},
		orderTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"采购", "1":"销售"};
			return arrivalStatusConfig[cellValue];
		},
		payTypeFormat(row, column, cellValue) {
			let payTypeConfig = {"0":"款到发货", "1":"快递代收", "2":"账期付款"};
			return payTypeConfig[cellValue];
		},
		arrivalStatusFormat(row, column, cellValue) {
			let arrivalStatusConfig = {};
			if (this.orderType == 0) {
				arrivalStatusConfig = {"0":"未到货", "1":"部分到货", "2":"全部到货", "3":"撤销"};
			} else {
				arrivalStatusConfig = {"0":"未发货", "1":"部分发货", "2":"全部发货", "3":"撤销"};
			}
			return arrivalStatusConfig[cellValue];
		},
		statusFormat(row, column, cellValue) {
			let statusConfig = {};
			if (row.orderType == 0) {
				statusConfig = {"0":"待审核","1":"待付款","2":"待收货","3":"收货中","4":"已到货","5":"已完结","6":"已撤销"};
			} else {
				statusConfig = {"0":"待审核","1":"待付款","2":"待发货","3":"发货中","4":"已发货","5":"已完结","6":"已撤销"};
			}
			return statusConfig[cellValue];
		},
		queryOrderTypeChange(value) {
			this.orderTypeChange(value, 0);
		},
		formOrderTypeChange(value) {
			this.orderTypeChange(value, 1);
		},
		orderTypeChange(value, target) {
			if(value === "") {
				if (target == 0) {
					this.queryCompanysKV = [];
				} else {
					this.formCompanysKV = [];
				}
			}
			let execQuery = value === "0"?getChannelKV:getAllCustomerKV;
			execQuery().then(res => { 
				if (res.code == 0 ) {
					if (target == 0) {
						this.queryCompanysKV = res.data;
					} else {
						this.formCompanysKV = res.data;
					}
				} else {
					this.$message.error("获取公司信息失败");
				}
            });
		},
		orderCompanyChange(value){
			let condition = {};
			condition["orderType"] = this.form.orderType;
			condition["orderCompanyId"] = value;
			this.ordersKV = [];
			fetchReconciliationOrders(condition).then(res=>{
				if (res.code == 0 ) {
					for (var i = 0; i < res.data.records.length; i++) {
						let orderItem = {};
						orderItem["key"] = res.data.records[i]["id"];
						orderItem["value"] = res.data.records[i]["orderNo"] + " - " + res.data.records[i]["orderCompanyName"] + " - " + res.data.records[i]["amount"] + "元 - " + res.data.records[i]["createTime"];
						this.ordersKV.push(orderItem);
					}
				} else {
					this.$message.error("获取订单数据失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchOrderWarningData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteOrderWarning([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveOrderWarning(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		handleShow(index, row) {
			getOrder(row.orderId).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.orderShowDetails = res.data.detailList;
					this.showVisible = true;
					this.orderType = row.orderType;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
